import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddPriorities } from "../api/AddPriorities";
import Spinner from 'react-bootstrap/Spinner';

export default function EditPrioritiesModal({
  openEditPriorties,
  handleCloseEditPriorities,
  editDetials,
}) {
  const [priorities, setPriorities] = useState(editDetials.priorities || "");
  const [errors, setErrors] = useState({ priorities: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "priority":
        setPriorities(value);
        setErrors((prevErrors) => ({
          ...prevErrors,
          priorities:
            value.trim().length > 10
              ? "Priority must be at least 10 characters long"
              : "",
        }));
        break;
      default:
        break;
    }
  };

  const validateSaveData = () => {
    const newErrors = {};
    if (!priorities.trim()) {
      newErrors.priorities = "Priority is required";
    } else if (!/^[0-9]{1,10}$/.test(priorities.trim())) {
      newErrors.priorities = "Priority must be a number";
    }
    return newErrors;
  };

  const handleSave = async () => {
    const errors = validateSaveData();
    setErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }
    try {
      setIsLoading(true)
      const userDetails = editDetials;
      const res = await AddPriorities({ priorities, userDetails });
      setIsLoading(false)
      handleCloseEditPriorities();
      if (res.status === 200) {
        toast.success(res.message);
      }
    } catch (error) {
      console.error("Error while saving priority:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault(); 
    handleSave();
  };

  return (
    <>
      <Modal show={openEditPriorties} onHide={handleCloseEditPriorities}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Priority</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="priority">
              <Form.Label>Edit Priority</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Priority"
                name="priority"
                value={priorities}
                onChange={handleInputChange}
                onBlur={handleInputChange}
                isInvalid={!!errors.priorities}
              />

              <Form.Control.Feedback type="invalid">
                {errors.priorities}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="mt-3">
          <Button
            style={{ backgroundColor: "#212529", color: "white" }}
            onClick={handleCloseEditPriorities}
          >
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#043174", color: "white" }}
            onClick={handleSave}
          >
            {isLoading ?
              <Spinner animation="border" size="sm" />
              :
              "Save"
            }
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
